<div mat-dialog-title>
  <span>{{'badges.modal.info.title' | translate}}</span>
  <button mat-dialog-close>
    <i class="fa fa-times"></i>
  </button>
</div>
@if (loadingState | async; as state) {
  <div class="badge__ctn">
    <mat-dialog-content>
      @if (state === actionState.READY) {
        <p>
          {{'badges.modal.info.value' | translate}} : {{badge.value}}
        </p>
        <p>
          {{'badges.modal.info.date' | translate}} : {{badge.date}}
        </p>
        <p>
          {{'badges.modal.info.type' | translate}} : {{badge.type}}
        </p>
        <p>
          {{'badges.modal.info.provider' | translate}} : {{badge.provider}}
        </p>
      }
      @if (state === actionState.FAILED) {
        <div class="app-display-errors-message" [error]="error"></div>
      }
      @if (state === actionState.LOADING) {
        <span class="ui-loading" [model]="{isLoading: true}"></span>
      }
    </mat-dialog-content>
  </div>
}